import React from 'react';
import Header from '../../../components/Header';
import ComponentHeader from '../../../components/ComponentHeader';
import SettingsSection from './SettingsSection';

const Settings = () => {
  return (
    <div className="flex-1 flex flex-col overflow-visible">
      <Header title={'Settings'} />
      <div className="flex-1 overflow-auto">
        <div className="flex justify-end mb-4">
          <ComponentHeader />
        </div>
        <div className="">
          <SettingsSection />
        </div>
      </div>
    </div>
  );
};

export default Settings;
